/*
  Orlivia : panier glissant.

  Trois regles de fond :

  1. On ne reconstruit jamais une ligne de panier. Les quantites passent par
     /cart/change.js avec l'identifiant de ligne, qui conserve les proprietes
     de la ligne. C'est par une propriete de ligne que l'application de packs
     accroche sa remise cote serveur : supprimer puis re-ajouter le produit
     ferait perdre le prix du pack.

  2. On n'invente aucun prix. Tout ce qui s'affiche vient de /cart.js :
     final_line_price, line_level_discount_allocations, total_discount,
     cart_level_discount_applications.

  3. Le format d'argent de la boutique contient du HTML (une balise span qui
     empeche la traduction automatique). Toute somme s'ecrit donc avec
     innerHTML, jamais textContent, sinon la balise s'affiche telle quelle.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-oi-cart]');
  if (!root) return;

  var panel = root.querySelector('.oi-cart__panel');
  var linesEl = root.querySelector('[data-oi-cart-lines]');
  var emptyEl = root.querySelector('[data-oi-cart-empty]');
  var countEl = root.querySelector('[data-oi-cart-count]');
  var totalEl = root.querySelector('[data-oi-cart-total]');
  var saveEl = root.querySelector('[data-oi-cart-save]');
  var wasEl = root.querySelector('[data-oi-cart-was]');
  /*
    Les messages d'urgence poses ailleurs dans le tiroir (sous la barre, au-dessus
    du total...). Ceux qui vont sur la ligne du produit vivent a part : ils ne
    s'affichent pas la ou Liquid les a ecrits, ils sont recopies ligne par ligne.
  */
  var urgEls = Array.prototype.slice.call(root.querySelectorAll('[data-oi-urg]')).filter(function (el) {
    return !el.closest('[data-oi-urg-line]');
  });

  /*
    Le vivier des messages de ligne. Un message central qui annonce trois pieces
    restantes ne dit pas de quelle couleur il parle : pose au-dessus des menus de
    la ligne, il n'y a plus de doute. Chaque ligne prend celui qui vise sa
    variante, couleur ou taille.
  */
  var urgLines = Array.prototype.slice.call(root.querySelectorAll('[data-oi-urg-line] [data-oi-urg]')).map(function (el) {
    var stock = {};
    (el.getAttribute('data-stock') || '').split(',').filter(Boolean).forEach(function (pair) {
      var kv = pair.split(':');
      stock[kv[0]] = parseInt(kv[1], 10) || 0;
    });
    // Un nombre ecrit a la main pour une taille precise, quand il y en a un.
    var qmap = {};
    (el.getAttribute('data-qmap') || '').split(',').filter(Boolean).forEach(function (pair) {
      var kv = pair.split(':');
      qmap[kv[0]] = parseInt(kv[1], 10) || 0;
    });
    return {
      ids: (el.getAttribute('data-vids') || '').split(',').filter(Boolean),
      all: el.getAttribute('data-always') === 'true',
      mode: el.getAttribute('data-mode') || 'manual',
      qty: parseInt(el.getAttribute('data-qty'), 10) || 0,
      max: parseInt(el.getAttribute('data-max'), 10) || 0,
      stock: stock,
      qmap: qmap,
      tpl: el.getAttribute('data-tpl') || '',
      style: el.getAttribute('style') || ''
    };
  });

  function urgFor(variantId) {
    if (!urgLines.length) return '';
    var vid = String(variantId);
    var out = '';
    urgLines.forEach(function (u) {
      if (out || !u.tpl) return;
      var aimed = u.ids.indexOf(vid) > -1;
      // Un message qui vise d'autres variantes ne sort pas ici. Sans variante
      // visee, il ne vaut que comme exemple : il faut qu'il soit regle dessus.
      if (!aimed && (u.ids.length || !u.all)) return;
      var n;
      if (u.mode === 'stock') {
        n = u.stock[vid] || 0;
        if (n <= 0 || (u.max && n > u.max)) return;
      } else {
        n = u.qmap[vid] || u.qty;
        if (n <= 0) return;
      }
      out = '<div class="oi-urg oi-urg--line"' + (u.style ? ' style="' + esc(u.style) + '"' : '') + '>' +
        u.tpl.replace('{n}', '<b>' + n + '</b>') + '</div>';
    });
    return out;
  }

  /*
    Combien de pieces restent pour cette variante. Le renseignement vient du
    bloc Urgence : soit le stock reel de la fiche, soit le nombre ecrit a la
    main. Sans bloc Urgence sur ce produit, on ne sait rien, et on repond null
    plutot que zero : ne pas savoir n'est pas etre epuise.
  */
  function stockFor(variantId) {
    if (!urgLines.length) return null;
    var vid = String(variantId);
    var found = null;
    urgLines.forEach(function (u) {
      if (found !== null) return;
      var aimed = u.ids.indexOf(vid) > -1;
      if (!aimed && (u.ids.length || !u.all)) return;
      var n = u.mode === 'stock' ? u.stock[vid] : (u.qmap[vid] || u.qty);
      if (n > 0) found = n;
    });
    return found;
  }

  /*
    Les labels a poser sur les photos. Ils sont ecrits une fois par Liquid dans
    un vivier cache : on les recopie ici, puis chaque ligne prend celui qui
    vise sa variante.
  */
  var badges = Array.prototype.slice.call(root.querySelectorAll('[data-oi-badge]')).map(function (el) {
    return {
      all: el.getAttribute('data-all') === 'true',
      ids: (el.getAttribute('data-vids') || '').split(',').filter(Boolean),
      html: el.outerHTML.replace(' hidden', '')
    };
  });

  function badgeFor(variantId) {
    var vid = String(variantId);
    var hit = '';
    var fallback = '';
    badges.forEach(function (b) {
      /*
        Un label vise une variante precise l'emporte toujours sur un label
        pose sur tout (l'exemple). Sinon l'exemple masquerait les vrais.
      */
      if (!hit && b.ids.indexOf(vid) > -1) hit = b.html;
      if (!fallback && b.all) fallback = b.html;
    });
    return hit || fallback;
  }
  var ctaEl = root.querySelector('[data-oi-cart-checkout]');
  var discEl = root.querySelector('[data-oi-disc]');
  var discRows = root.querySelector('[data-oi-disc-rows]');
  var discRemove = discEl ? discEl.getAttribute('data-remove-on') === 'true' : false;
  var discRemoveLabel = (discEl && discEl.getAttribute('data-remove-label')) || 'Retirer';
  var appliedCodes = [];
  var goalsEl = root.querySelector('[data-oi-goals]');
  var goalsMsg = root.querySelector('[data-oi-goals-msg]');
  var goalsFill = root.querySelector('[data-oi-goals-fill]');
  var goalsMarks = root.querySelector('.oi-goals__marks');
  var footScroll = root.querySelector('.oi-cart__footscroll');
  var timerEl = root.querySelector('[data-oi-timer]');
  var promoInput = root.querySelector('[data-oi-promo-input]');
  var promoBtn = root.querySelector('[data-oi-promo-apply]');
  var promoNote = root.querySelector('[data-oi-promo-note]');

  /*
    Typographie francaise du prix : le symbole passe apres le montant, precede
    d'une espace insecable, pour que « 12,90 € » ne se coupe jamais en fin de
    ligne. Le reglage de la boutique peut encore ecrire « €12,90 » a l'anglaise :
    on remet l'ordre ici plutot que d'esperer que chaque endroit y pense.
    Un format sans symbole euro (autre devise) n'est pas touche.
  */
  function frMoney(fmt) {
    var token = '(\\{\\{\\s*\\w+\\s*\\}\\})';
    return String(fmt)
      .replace(new RegExp('\u20ac[\\s\u00a0]*' + token, 'g'), '$1\u00a0\u20ac')
      .replace(new RegExp(token + '[\\s\u00a0]*\u20ac', 'g'), '$1\u00a0\u20ac');
  }

  var cfg = {
    skin: root.getAttribute('data-oi-skin') || 'side',
    money: frMoney(root.getAttribute('data-money-format') || '{{amount_with_comma_separator}}\u00a0€'),
    goalsOn: root.getAttribute('data-goals-enable') === 'true',
    goalsAnim: root.getAttribute('data-goals-anim') || 'confetti',
    goalsNext: root.getAttribute('data-goals-next') || '',
    goalsDone: root.getAttribute('data-goals-done') || '',
    goalsTodo: root.getAttribute('data-goals-todo') || '',
    giftLabel: root.getAttribute('data-gift-label') || '',
    saveText: root.getAttribute('data-save-text') || '',
    giftFirst: root.getAttribute('data-gift-first') === 'true',
    openOnAdd: root.getAttribute('data-open-on-add') === 'true',
    ctaTotal: root.getAttribute('data-cta-total') === 'true',
    ctaLabel: root.getAttribute('data-cta-label') || '',
    lineVariants: root.getAttribute('data-line-variants') === 'true',
    lineGroup: root.getAttribute('data-line-group') === 'true',
    lineGroupFirst: root.getAttribute('data-line-group-first') || 'added',
    soldout: root.getAttribute('data-soldout-label') || 'Epuise',
    packLocked: root.getAttribute('data-pack-locked') || '',
    dealPct: parseInt(root.getAttribute('data-reco-deal'), 10) || 0,
    dealCode: root.getAttribute('data-reco-deal-code') || '',
    prioVids: (root.getAttribute('data-prio-vids') || '').split(',').filter(Boolean),
    btnPrice: root.getAttribute('data-reco-btn-price') === 'true'
  };

  // Le prix reellement affiche sur une proposition, remise upsell comprise.
  function dealPrice(cents) {
    if (!cfg.dealPct) return cents;
    return Math.round((cents * (100 - cfg.dealPct)) / 100);
  }

  /*
    Le tiroir ne prend la main que s'il est active dans le theme, ou si on
    l'essaie avec ?oi-panier=1 dans l'adresse. L'essai est retenu le temps de
    la visite, pour pouvoir naviguer sans remettre le parametre a chaque page.
    ?oi-panier=0 arrete l'essai.
  */
  var TRY_KEY = 'orlivia:panier:essai';
  var q = location.search;
  try {
    if (/[?&]oi-panier=1/.test(q)) sessionStorage.setItem(TRY_KEY, '1');
    if (/[?&]oi-panier=0/.test(q)) sessionStorage.removeItem(TRY_KEY);
  } catch (e) {}
  var trying = false;
  try { trying = sessionStorage.getItem(TRY_KEY) === '1'; } catch (e) {}

  if (root.getAttribute('data-oi-enabled') !== 'true' && !trying) {
    root.parentNode.removeChild(root);
    return;
  }

  /*
    Deux tiroirs ne peuvent pas se partager les memes clics. L'application de
    panier en place lit elle-meme un drapeau au moment du clic pour laisser la
    main : on le pose des que notre tiroir est actif. Si on le desactive, le
    sien reprend la main tout seul au rechargement.
  */
  try { window.__kachingCartDisabled = true; } catch (e) {}

  var busy = false;
  var lastFocus = null;
  var lastCart = null;
  var pinKey = null;    // la ligne qui garde sa place apres un changement
  var pinFresh = false;
  var pinAt = null;     // la place qu'occupait la ligne modifiee
  var pinVariant = '';  // le variant attendu, quand la nouvelle cle est inconnue
  var pinSig = '';

  /*
    Deux lignes du panier sont la meme ligne quand elles portent la meme
    variante ET les memes options. On compare les options par une signature
    stable : l'ordre des cles renvoye par Shopify n'est pas garanti, et une
    option vide ne compte pas. Sans ca, on croit avoir affaire a deux lignes
    differentes et on en cree une de trop.
  */
  function propSig(p) {
    var o = p || {};
    var ks = Object.keys(o).sort();
    var out = [];
    var i;
    for (i = 0; i < ks.length; i++) {
      var v = o[ks[i]];
      if (v === '' || v == null) continue;
      out.push(ks[i] + '=' + v);
    }
    return out.join('|');
  }

  /* --- argent ------------------------------------------------------- */

  function group(num, sepThousands, sepDecimal, decimals) {
    var n = (num / 100).toFixed(decimals);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sepThousands);
    return decimals ? parts.join(sepDecimal) : parts[0];
  }

  function money(cents) {
    var v = typeof cents === 'number' ? cents : 0;
    return cfg.money.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case 'amount': return group(v, ',', '.', 2);
        case 'amount_no_decimals': return group(v, ',', '.', 0);
        case 'amount_with_comma_separator': return group(v, '.', ',', 2);
        case 'amount_no_decimals_with_comma_separator': return group(v, '.', ',', 0);
        case 'amount_with_space_separator': return group(v, ' ', ',', 2);
        case 'amount_no_decimals_with_space_separator': return group(v, ' ', ',', 0);
        case 'amount_with_apostrophe_separator': return group(v, "'", '.', 2);
        default: return group(v, '.', ',', 2);
      }
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Certaines applications etiquettent leur remise avec une ponctuation en
  // tete (« : Lot »). On la retire pour que la ligne se lise normalement.
  function dealTitle(t) {
    return String(t || '').replace(/^[\s:;,\-–]+/, '').trim();
  }

  function sized(url, w) {
    if (!url) return '';
    return url.replace(/(\.[a-z]{3,4})(\?|$)/i, '_' + w + 'x$1$2');
  }

  /* --- reseau ------------------------------------------------------- */

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(url);
      return r.json();
    });
  }

  function setBusy(on) {
    busy = on;
    root.classList.toggle('is-busy', on);
  }

  function changeLine(key, qty) {
    if (busy) return Promise.resolve(null);
    setBusy(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; })
      .catch(function () { return getCart().then(render); })
      .then(function (c) { setBusy(false); return c; });
  }

  /*
    Ajouter une proposition. /cart/add.js ne renvoie que la ligne ajoutee : il
    faut ensuite relire le panier, donc deux allers-retours. /cart/update.js
    accepte une quantite absolue par identifiant de variante et renvoie le
    panier complet : un seul aller-retour. On part de la quantite deja au
    panier, connue par le dernier rendu, et on retombe sur add.js si jamais
    l'appel echoue.
  */
  function addVariant(id, qty) {
    if (busy) return Promise.resolve(null);
    setBusy(true);
    var want = qty || 1;
    if (lastCart && lastCart.items) {
      lastCart.items.forEach(function (it) {
        if (String(it.variant_id) === String(id) && !hasPackProps(it)) want += it.quantity;
      });
    }
    var updates = {};
    updates[String(id)] = want;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('update');
        return r.json();
      })
      .catch(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
        }).then(function () { return getCart(); });
      })
      .then(function (cart) { render(cart); setBusy(false); applyDealCode(); return cart; })
      .catch(function () { setBusy(false); });
  }

  function hasPackProps(item) {
    var props = item.properties || {};
    return Object.keys(props).some(function (k) { return k.charAt(0) === '_'; });
  }

  /*
    Le prix special des propositions ne s'invente pas cote theme : c'est une
    reduction creee dans Shopify, limitee a ces produits. On se contente de la
    poser sur le panier apres l'ajout, une seule fois, et Shopify decide si
    elle s'applique.
  */
  function applyDealCode() {
    if (!cfg.dealCode) return;
    if (appliedCodes.some(function (c) { return c.toLowerCase() === cfg.dealCode.toLowerCase(); })) return;
    var codes = appliedCodes.concat([cfg.dealCode]);
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) render(cart); })
      .catch(function () {});
  }

  /* --- variantes : taille et couleur, dans le panier et sur les upsells --- */

  var prodCache = {};

  function shopRoot() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  function getProduct(handle) {
    if (prodCache[handle]) return prodCache[handle];
    prodCache[handle] = fetch(shopRoot() + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return prodCache[handle];
  }

  // Le variant qui correspond a ce que la cliente a choisi dans les menus.
  function resolveVariant(box) {
    var list = [];
    try { list = JSON.parse(box.getAttribute('data-oi-variants') || '[]'); } catch (e) { list = []; }
    var picked = Array.prototype.map.call(box.querySelectorAll('[data-oi-opt]'), function (el) { return el.value; });
    var found = null;
    list.forEach(function (v) {
      if (found || !v.o) return;
      var ok = true;
      picked.forEach(function (val, i) { if (v.o[i] !== val) ok = false; });
      if (ok) found = v;
    });
    return found;
  }

  function optName(o) { return typeof o === 'string' ? o : (o && o.name) || ''; }

  // Les lignes du panier n'ont pas la liste des variantes : on va la chercher.
  function hydrateLineOpts() {
    Array.prototype.forEach.call(root.querySelectorAll('[data-oi-line-opts]'), function (box) {
      var handle = box.getAttribute('data-handle');
      if (!handle) return;
      var current = box.getAttribute('data-variant');
      if (box.getAttribute('data-built') === current) return;
      getProduct(handle).then(function (prod) {
        if (!prod || !prod.variants || prod.variants.length < 2) return;
        var cur = null;
        prod.variants.forEach(function (v) { if (String(v.id) === String(current)) cur = v; });
        if (!cur) cur = prod.variants[0];
        box.setAttribute('data-oi-variants', JSON.stringify(prod.variants.map(function (v) {
          return {
            id: v.id, o: v.options, a: v.available, p: v.price,
            i: (v.featured_image && v.featured_image.src) || ''
          };
        })));
        box.innerHTML = (prod.options || []).map(function (o, i) {
          var vals = [];
          prod.variants.forEach(function (v) {
            if (v.options[i] && vals.indexOf(v.options[i]) === -1) vals.push(v.options[i]);
          });
          if (vals.length < 2 && vals[0] === 'Default Title') return '';
          return '<select class="oi-opt" data-oi-opt="' + i + '" aria-label="' + esc(optName(o)) + '">' +
            vals.map(function (val) {
              return '<option value="' + esc(val) + '"' + (val === cur.options[i] ? ' selected' : '') + '>' + esc(val) + '</option>';
            }).join('') +
          '</select>';
        }).join('');
        box.setAttribute('data-built', current);
      });
    });
  }

  /*
    Changer de taille ou de couleur. Shopify ne sait pas modifier le variant
    d'une ligne : on retire l'ancienne et on met la nouvelle dans le meme
    aller-retour. Trois regles tenues ici, dans cet ordre :
      1. on repart du panier tel qu'il est vraiment (les cles de ligne bougent
         des qu'une appli touche au panier, et une cle perimee fait tout rater) ;
      2. la couleur choisie deja presente ne cree pas une seconde ligne : on
         ajoute la quantite a la ligne existante ;
      3. on verifie que l'ancienne ligne a bien disparu, et on la retire pour
         de bon si elle est encore la.
    La ligne qui en sort reprend la place de celle qu'on vient de modifier.
  */
  function swapVariant(key, newId, box) {
    if (busy) return;
    setBusy(true);
    var oldVariant = '';
    var sig = '';
    var qty = 0;

    function note(txt) {
      var line = box.closest('[data-oi-line]');
      var el = line && line.querySelector('[data-oi-line-note]');
      if (!el) return;
      el.hidden = !txt;
      el.textContent = txt || '';
    }
    note('');

    /*
      La place qu'occupe la ligne en train d'etre modifiee. C'est elle que la
      nouvelle couleur va reprendre : on voit le changement sous les yeux, la
      ligne ne part pas ailleurs dans le panier.
    */
    var lineEl = box.closest('[data-oi-line]');
    pinAt = lineEl && linesEl ? Array.prototype.indexOf.call(linesEl.children, lineEl) : null;
    if (pinAt !== null && pinAt < 0) pinAt = null;
    pinVariant = String(newId);
    pinSig = '';
    pinKey = null;
    pinFresh = true;

    function post(url, body) {
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('swap');
        return r.json();
      });
    }

    /*
      Retrouver la ligne d'origine dans un panier qui vient de bouger. On tente
      d'abord sa cle ; si Shopify l'a regeneree (ca arrive des qu'une appli de
      remise recalcule le panier), on la reconnait a son couple variante +
      options. Sans ce repli, on demandait la suppression d'une cle perimee :
      l'appel echouait, l'ancienne couleur restait, et le message d'erreur
      tombait alors que l'ajout, lui, avait bien eu lieu.
    */
    function findOld(cart) {
      var hit = null;
      var list = cart && cart.items ? cart.items : [];
      var i;
      for (i = 0; i < list.length; i++) {
        if (list[i].key === key) return list[i];
      }
      if (!oldVariant) return null;
      for (i = 0; i < list.length; i++) {
        if (String(list[i].variant_id) !== String(oldVariant)) continue;
        if (propSig(list[i].properties) !== sig) continue;
        hit = list[i];
        break;
      }
      return hit;
    }

    // Ajouter la nouvelle couleur, puis retirer l'ancienne ligne telle qu'elle
    // est vraiment a ce moment-la. Deux allers-retours, jamais de cle devinee.
    function addThenRemove(props) {
      return post('/cart/add.js', { items: [{ id: newId, quantity: qty, properties: props }] })
        .then(getCart)
        .then(function (cart) {
          var old = findOld(cart);
          if (!old) return cart;
          return post('/cart/change.js', { id: old.key, quantity: 0 });
        });
    }

    // Filet de securite : l'ancienne ligne ne doit plus etre la, quoi qu'il arrive.
    function ensureGone(cart) {
      var old = findOld(cart);
      if (!old) return cart;
      return post('/cart/change.js', { id: old.key, quantity: 0 }).catch(getCart);
    }

    getCart()
      .then(function (cart) {
        var mine = null;
        (cart.items || []).forEach(function (it) {
          if (it.key === key) mine = it;
        });

        // La ligne n'existe plus (une appli est passee par la) : on se contente d'afficher.
        if (!mine) { pinFresh = false; return cart; }

        oldVariant = mine.variant_id;
        qty = mine.quantity;
        sig = propSig(mine.properties);
        pinSig = sig;
        var props = mine.properties || {};

        // Rien a faire : c'est deja cette couleur-la.
        if (String(oldVariant) === String(newId)) { pinFresh = false; return cart; }

        var twin = null;
        var others = 0;
        (cart.items || []).forEach(function (it) {
          if (it.key === key) return;
          if (String(it.variant_id) !== String(newId)) return;
          others += it.quantity;
          if (!twin && propSig(it.properties) === sig) twin = it;
        });

        /*
          La couleur choisie est deja au panier avec les memes options : on ne
          cree pas une seconde ligne, on ajoute la quantite a celle qui existe
          et on supprime l'ancienne dans le meme aller-retour.
        */
        if (twin) {
          var merge = {};
          merge[key] = 0;
          merge[twin.key] = twin.quantity + qty;
          pinKey = twin.key;
          return post('/cart/update.js', { updates: merge }).catch(function () {
            pinKey = null;
            return addThenRemove(props);
          });
        }

        /*
          Une ligne de meme variante mais d'autres options (un pack) existe
          deja : passer par l'identifiant de variante ecraserait sa quantite,
          car Shopify le lit comme un total. On passe alors par l'ajout.
        */
        if (others > 0 || Object.keys(props).length > 0) return addThenRemove(props);

        var updates = {};
        updates[key] = 0;
        updates[String(newId)] = qty;
        return post('/cart/update.js', { updates: updates }).catch(function () {
          return addThenRemove(props);
        });
      })
      .then(ensureGone)
      .then(function (cart) {
        render(cart);
        setBusy(false);
        return cart;
      })
      .catch(function () {
        setBusy(false);
        pinKey = null;
        pinAt = null;
        pinVariant = '';
        pinFresh = false;
        // Le message ne s'affiche que si le changement a vraiment echoue :
        // une erreur en cours de route dont on s'est releve n'inquiete personne.
        return getCart().then(function (cart) {
          render(cart);
          if (findOld(cart)) note(cfg.packLocked);
        });
      });
  }

  // Une fleche qui ne mene nulle part ne sert a rien : on la masque.
  function syncRailNav() {
    Array.prototype.forEach.call(root.querySelectorAll('[data-oi-rail]'), function (rail) {
      var wrap = rail.parentNode;
      var prev = wrap.querySelector('[data-oi-rail-nav="-1"]');
      var next = wrap.querySelector('[data-oi-rail-nav="1"]');
      var max = rail.scrollWidth - rail.clientWidth;
      if (prev) prev.hidden = rail.scrollLeft <= 2;
      if (next) next.hidden = max <= 2 || rail.scrollLeft >= max - 2;
    });
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-oi-rail]'), function (rail) {
    rail.addEventListener('scroll', syncRailNav, { passive: true });
  });

  /* --- descendre d'un produit ----------------------------------------- */

  /*
    Quand la liste depasse la hauteur visible, un rond apparait au bord du
    voile. Chaque appui amene le produit suivant en haut de la zone, jusqu'au
    bas du panier ; arrive en bas, le rond disparait.
  */
  var bodyEl = root.querySelector('.oi-cart__body');
  var nextBtn = root.querySelector('[data-oi-scroll-next]');

  function syncNextBtn() {
    if (!nextBtn || !bodyEl) return;
    var max = bodyEl.scrollHeight - bodyEl.clientHeight;
    nextBtn.hidden = max <= 8 || bodyEl.scrollTop >= max - 8;
  }

  function scrollNext() {
    if (!bodyEl) return;
    var top = bodyEl.scrollTop;
    var target = null;
    Array.prototype.forEach.call(bodyEl.querySelectorAll('[data-oi-line]'), function (el) {
      if (target !== null) return;
      if (el.offsetTop > top + 6) target = el.offsetTop;
    });
    if (target === null) target = bodyEl.scrollHeight;
    bodyEl.scrollTo({ top: target, behavior: 'smooth' });
  }

  if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); scrollNext(); });
  if (bodyEl) bodyEl.addEventListener('scroll', syncNextBtn, { passive: true });
  window.addEventListener('resize', syncNextBtn, { passive: true });
  // Rotation de l'ecran : les colonnes des paliers se recalculent.
  window.addEventListener('resize', function () { layoutMarks(); }, { passive: true });

  root.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('.oi-opt') : null;
    if (!sel) return;

    var recoBox = sel.closest('.oi-reco__opts');
    if (recoBox) {
      var rv = resolveVariant(recoBox);
      var card = recoBox.closest('.oi-reco__card');
      var btn = card && card.querySelector('.oi-reco__btn');
      var price = card && card.querySelector('.oi-reco__price');
      if (btn) {
        if (rv && rv.a) {
          btn.disabled = false;
          btn.setAttribute('data-oi-cart-add', rv.id);
          var label = btn.getAttribute('data-add-label') || btn.textContent;
          if (cfg.btnPrice) btn.innerHTML = esc(label) + ' \u00b7 ' + money(dealPrice(rv.p));
          else btn.textContent = label;
        } else {
          btn.disabled = true;
          btn.removeAttribute('data-oi-cart-add');
          btn.textContent = cfg.soldout;
        }
      }
      if (price && rv) {
        price.innerHTML = cfg.dealPct
          ? '<s>' + money(rv.p) + '</s> ' + money(dealPrice(rv.p))
          : money(rv.p);
      }
      // La vignette suit la couleur choisie, tout de suite.
      if (rv && rv.i) {
        var rimg = card && card.querySelector('.oi-reco__img img');
        if (rimg) rimg.src = sized(rv.i, 480);
      }
      return;
    }

    var lineBox = sel.closest('[data-oi-line-opts]');
    if (!lineBox) return;
    var line = lineBox.closest('[data-oi-line]');
    var note = line && line.querySelector('[data-oi-line-note]');
    var nv = resolveVariant(lineBox);
    if (!nv || !nv.a) {
      if (note) { note.hidden = false; note.textContent = cfg.soldout; }
      return;
    }
    if (note) note.hidden = true;
    if (nv.i) {
      var limg = line && line.querySelector('.oi-line__img img');
      if (limg) limg.src = sized(nv.i, 300);
    }
    if (String(nv.id) === lineBox.getAttribute('data-variant')) return;
    swapVariant(line.getAttribute('data-oi-line'), nv.id, lineBox);
  });

  /* --- rendu des lignes ---------------------------------------------- */

  function lineHtml(item, index, sub) {
    var img = item.image ? sized(item.image, 300) : '';
    var opts = [];
    if (item.options_with_values) {
      item.options_with_values.forEach(function (o) {
        if (o.value && o.value !== 'Default Title') opts.push(o.value);
      });
    }

    // Prix : ce que Shopify facture reellement pour la ligne, remise comprise.
    var full = item.original_line_price;
    var now = item.final_line_price;
    /*
      Une ligne a zero est un cadeau : on ecrit le mot, pas le chiffre. Le prix
      d'origine reste barre a cote quand il y en avait un, ca montre la valeur
      de ce qui est offert.
    */
    var isGift = now === 0;
    var priceHtml;
    if (isGift && cfg.giftLabel) {
      priceHtml = (full > 0 ? '<s>' + money(full) + '</s>' : '') + esc(cfg.giftLabel);
    } else if (now < full) {
      priceHtml = '<s>' + money(full) + '</s>' + money(now);
    } else {
      priceHtml = money(now);
    }

    // Nom de la remise, tel que le serveur l'a etiquetee (packs compris).
    var deals = '';
    (item.line_level_discount_allocations || []).forEach(function (d) {
      var title = dealTitle(d.discount_application && d.discount_application.title);
      if (title && (d.amount || 0) > 0) deals += '<span class="oi-line__deal">' + esc(title) + ' &minus;' + money(d.amount) + '</span>';
    });

    /*
      Les options en menus deroulants. Une ligne de pack (propriete masquee,
      prefixee d'un underscore) est modifiable elle aussi : ses proprietes sont
      recopiees telles quelles sur la nouvelle ligne, donc la remise du pack
      suit. Si le serveur refuse, un message s'affiche sous la ligne.
    */
    var props = item.properties || {};
    var inPack = Object.keys(props).some(function (k) { return k.charAt(0) === '_'; });
    /*
      Une ligne posee par un cadeau ne s'ajuste pas : ni quantite, ni retrait.
      C'est la condition qui la fait vivre, et c'est elle qui la reprendra.
    */
    var given = !!props[GIFT_PROP];
    var swappable = cfg.lineVariants && opts.length > 0;
    var optHtml = opts.length ? '<p class="oi-line__opt">' + esc(opts.join(' / ')) + '</p>' : '';
    if (given) swappable = false;
    if (swappable) {
      optHtml =
        '<div class="oi-line__opts" data-oi-line-opts' +
          ' data-handle="' + esc(item.handle || '') + '"' +
          ' data-variant="' + item.variant_id + '"' +
          ' data-qty="' + item.quantity + '"' +
          ' data-pack="' + (inPack ? '1' : '0') + '"' +
          ' data-props="' + esc(JSON.stringify(props)) + '">' +
          '<p class="oi-line__opt">' + esc(opts.join(' / ')) + '</p>' +
        '</div>' +
        '<span class="oi-line__note" data-oi-line-note hidden></span>';
    }

    return (
      '<div class="oi-line' + (isGift ? ' oi-line--gift' : '') + (sub ? ' oi-line--sub' : '') + '" data-oi-line="' + esc(item.key) + '" data-oi-index="' + (index + 1) + '">' +
        /* Une variante rangee sous une autre ne repete ni la photo ni le nom. */
        (sub ? '' :
          '<a class="oi-line__img" href="' + esc(item.url) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '') +
            badgeFor(item.variant_id) +
          '</a>') +
        '<div class="oi-line__info">' +
          '<p class="oi-line__name">' + esc(item.product_title) + '</p>' +
          urgFor(item.variant_id) +
          optHtml +
          '<div class="oi-line__row">' +
            (given
              ? '<span class="oi-qty oi-qty--fixed">' + item.quantity + '</span>'
              : '<span class="oi-qty">' +
                  '<button type="button" data-oi-qty="-1" aria-label="Retirer un">&minus;</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-oi-qty="1" aria-label="Ajouter un">+</button>' +
                '</span>') +
            '<span class="oi-line__price">' + priceHtml + '</span>' +
          '</div>' +
          deals +
          (given
            ? ''
            /* Sous une autre variante, la place manque : « Retirer » devient une croix. */
            : '<div class="oi-line__row"' + (sub ? '' : ' style="margin-top:6px"') + '>' +
                '<button type="button" class="oi-line__del" data-oi-del' +
                  (sub ? ' aria-label="Retirer cette taille">&times;' : '>Retirer') +
                '</button>' +
              '</div>') +
        '</div>' +
      '</div>'
    );
  }

  /* --- paliers d'objectif -------------------------------------------- */

  var tiers = [];
  if (goalsEl) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-oi-mark]'), function (m) {
      tiers.push({
        n: m.getAttribute('data-oi-mark'),
        amount: parseInt(m.getAttribute('data-amount'), 10) || 0,
        label: m.getAttribute('data-label') || '',
        reached: m.getAttribute('data-reached') || '',
        mark: m,
        todo: m.querySelector('[data-oi-mark-todo]'),
        dot: root.querySelector('[data-oi-dot="' + m.getAttribute('data-oi-mark') + '"]')
      });
    });
    tiers.sort(function (a, b) { return a.amount - b.amount; });
  }
  var goalMax = tiers.length ? tiers[tiers.length - 1].amount : 0;
  var lastReached = null;   // null = premier rendu, on ne fete rien
  var celebrateTimer = null;

  function confetti() {
    if (!goalsEl || !window.requestAnimationFrame) return;
    var box = goalsEl.getBoundingClientRect();
    var cv = document.createElement('canvas');
    cv.className = 'oi-confetti';
    cv.width = Math.max(1, Math.round(box.width));
    cv.height = Math.max(1, Math.round(box.height));
    goalsEl.style.position = 'relative';
    goalsEl.appendChild(cv);
    var ctx = cv.getContext('2d');
    if (!ctx) { goalsEl.removeChild(cv); return; }

    var colors = ['#d98f4e', '#8a6a4b', '#e4c9a8', '#c25b5b', '#4e7d6e'];
    var bits = [];
    for (var i = 0; i < 70; i++) {
      bits.push({
        x: cv.width * (0.15 + Math.random() * 0.7),
        y: cv.height * 0.5,
        vx: (Math.random() - 0.5) * 5,
        vy: -2 - Math.random() * 5,
        w: 3 + Math.random() * 4,
        h: 5 + Math.random() * 6,
        r: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.4,
        c: colors[(Math.random() * colors.length) | 0]
      });
    }
    var frames = 0;
    (function step() {
      frames++;
      ctx.clearRect(0, 0, cv.width, cv.height);
      bits.forEach(function (b) {
        b.vy += 0.16;
        b.x += b.vx;
        b.y += b.vy;
        b.r += b.vr;
        ctx.save();
        ctx.translate(b.x, b.y);
        ctx.rotate(b.r);
        ctx.fillStyle = b.c;
        ctx.fillRect(-b.w / 2, -b.h / 2, b.w, b.h);
        ctx.restore();
      });
      if (frames < 95) requestAnimationFrame(step);
      else if (cv.parentNode) cv.parentNode.removeChild(cv);
    })();
  }

  function celebrate(tier) {
    if (!goalsEl) return;
    if (cfg.goalsAnim === 'confetti') confetti();
    else if (cfg.goalsAnim === 'pulse' || cfg.goalsAnim === 'shine') {
      var cl = cfg.goalsAnim === 'pulse' ? 'is-pulse' : 'is-shine';
      goalsEl.classList.remove(cl);
      void goalsEl.offsetWidth;
      goalsEl.classList.add(cl);
      setTimeout(function () { goalsEl.classList.remove(cl); }, 1200);
    }
    if (tier && tier.reached && goalsMsg) {
      goalsMsg.innerHTML = '<b>' + esc(tier.reached) + '</b>';
      clearTimeout(celebrateTimer);
      celebrateTimer = setTimeout(function () { goalsText(currentTotal); }, 4000);
    }
  }

  var currentTotal = 0;

  /*
    Fait descendre le haut du pied jusqu'a la liste des remises. Le total et le
    bouton de paiement, eux, ne bougent jamais : ils sont hors de cette zone.
  */
  function showDiscounts() {
    if (!footScroll) return;
    setTimeout(function () {
      var to = footScroll.scrollHeight - footScroll.clientHeight;
      if (to <= 0) return;
      if (footScroll.scrollTo) footScroll.scrollTo({ top: to, behavior: 'smooth' });
      else footScroll.scrollTop = to;
    }, 60);
  }

  function goalsText(total) {
    if (!goalsMsg) return;
    var next = null;
    for (var i = 0; i < tiers.length; i++) {
      if (total < tiers[i].amount) { next = tiers[i]; break; }
    }
    if (next) {
      goalsMsg.innerHTML = esc(cfg.goalsNext)
        .replace('[reste]', '<b>' + money(next.amount - total) + '</b>')
        .replace('[objectif]', '<b>' + esc(next.label) + '</b>');
    } else {
      goalsMsg.innerHTML = '<b>' + esc(cfg.goalsDone) + '</b>';
    }
  }

  /*
    Deux libelles cote a cote se chevauchent des que la barre est etroite. On
    ne les empile pas : on leur donne a chacun une colonne de meme largeur,
    tous sur la meme ligne, cales le plus pres possible de leur pastille. Le
    resultat reste aligne, quel que soit le nombre de paliers.
  */
  function layoutMarks() {
    if (!goalsMarks || tiers.length < 2 || !goalMax) return;
    var W = goalsMarks.getBoundingClientRect().width;
    // Tiroir encore ferme : rien n'a de largeur, la mesure ne veut rien dire.
    if (!W) return;

    var gut = 8;
    var w = Math.floor(W / tiers.length) - gut;
    if (w < 64) w = 64;
    if (w > W) w = W;

    var boxes = tiers.map(function (t) {
      return { t: t, left: (t.amount / goalMax) * W - w / 2 };
    });
    // On pousse vers la droite ce qui deborde a gauche, puis l'inverse :
    // chaque libelle finit au plus pres de sa pastille, sans mordre sur son voisin.
    var edge = 0;
    boxes.forEach(function (b) {
      if (b.left < edge) b.left = edge;
      edge = b.left + w + gut;
    });
    edge = W;
    for (var i = boxes.length - 1; i >= 0; i--) {
      if (boxes[i].left + w > edge) boxes[i].left = edge - w;
      edge = boxes[i].left - gut;
    }

    var h = 0;
    boxes.forEach(function (b) {
      var st = b.t.mark.style;
      st.width = w + 'px';
      st.transform = 'none';
      st.top = '0px';
      st.left = Math.round(Math.max(0, b.left)) + 'px';
    });
    boxes.forEach(function (b) {
      var hh = b.t.mark.getBoundingClientRect().height;
      if (hh > h) h = hh;
    });
    if (h) goalsMarks.style.height = Math.ceil(h) + 'px';
  }

  function renderGoals(cart) {
    if (!goalsEl || !cfg.goalsOn || !goalMax) return;
    // Un cadeau deja obtenu ne compte pas dans le montant qui debloque le suivant.
    var total = netTotal(cart);
    currentTotal = total;

    goalsText(total);
    if (goalsFill) {
      goalsFill.style.width = Math.min(100, Math.round((total / goalMax) * 100)) + '%';
    }

    var top = null;
    tiers.forEach(function (t) {
      var on = total >= t.amount;
      t.mark.classList.toggle('is-on', on);
      if (t.dot) t.dot.classList.toggle('is-on', on);
      // Sous un palier pas encore atteint : ce qu'il reste a mettre au panier.
      if (t.todo) {
        t.todo.innerHTML = on ? '' : esc(cfg.goalsTodo).replace('[reste]', money(t.amount - total));
      }
      if (on) top = t;
    });

    // Premier rendu : on note l'etat sans rien feter.
    layoutMarks();

    if (lastReached === null) { lastReached = top ? top.amount : 0; return; }
    if (top && top.amount > lastReached) celebrate(top);
    lastReached = top ? top.amount : 0;
  }

  /* --- rendu general -------------------------------------------------- */

  /*
    Les messages d'urgence. Chaque bloc vise une liste de variantes : il ne se
    montre que si l'une d'elles est au panier, sauf si le bloc est regle sur
    « afficher meme hors panier ». Le nombre vient soit du reglage, soit du
    stock reel de la variante trouvee.
  */
  function renderUrgency(cart) {
    if (!urgEls.length) return;
    var inCart = {};
    (cart.items || []).forEach(function (it) { inCart[String(it.variant_id)] = true; });

    urgEls.forEach(function (el) {
      var ids = (el.getAttribute('data-vids') || '').split(',').filter(Boolean);
      var always = el.getAttribute('data-always') === 'true';

      var hitId = null;
      ids.forEach(function (id) { if (!hitId && inCart[id]) hitId = id; });

      // Sans variante visee, le message ne vaut que comme exemple : il ne
      // sort donc que s'il est regle sur « afficher meme hors panier ».
      if (!hitId && !always) { el.hidden = true; return; }

      var n;
      if (el.getAttribute('data-mode') === 'stock') {
        var map = {};
        (el.getAttribute('data-stock') || '').split(',').filter(Boolean).forEach(function (pair) {
          var kv = pair.split(':');
          map[kv[0]] = parseInt(kv[1], 10) || 0;
        });
        n = map[hitId || ids[0]] || 0;
        var max = parseInt(el.getAttribute('data-max'), 10) || 0;
        if (n <= 0 || (max && n > max)) { el.hidden = true; return; }
      } else {
        /*
          Un nombre par taille l'emporte sur le nombre general : c'est le plus
          precis des deux, et c'est celui de la variante qui est au panier.
        */
        var qm = {};
        (el.getAttribute('data-qmap') || '').split(',').filter(Boolean).forEach(function (pair) {
          var kv = pair.split(':');
          qm[kv[0]] = parseInt(kv[1], 10) || 0;
        });
        n = qm[hitId] || parseInt(el.getAttribute('data-qty'), 10) || 0;
        if (n <= 0) { el.hidden = true; return; }
      }

      el.innerHTML = (el.getAttribute('data-tpl') || '').replace('{n}', '<b>' + n + '</b>');
      el.hidden = false;
    });
  }

  /* --- cadeaux et recompenses ----------------------------------------- */

  /*
    Un cadeau, c'est une condition et une recompense. La condition se lit sur
    le panier (un montant, un nombre d'articles, la presence d'un produit) et
    la recompense s'applique toute seule : le produit s'ajoute, le code se
    pose. Quand la condition retombe, on defait ce qu'on avait fait, et rien
    d'autre : un code entre a la main par la cliente n'est jamais retire.

    La ligne offerte porte une propriete cachee qui dit de quel cadeau elle
    vient. C'est ce qui permet de la reconnaitre au rendu suivant, et c'est
    aussi ce qui l'exclut du calcul des conditions : un cadeau ne doit jamais
    servir a debloquer le cadeau suivant.
  */
  var GIFT_PROP = '_cadeau';
  var gifts = Array.prototype.slice.call(root.querySelectorAll('[data-oi-gift]')).map(function (el) {
    return {
      id: el.getAttribute('data-id') || '',
      cond: el.getAttribute('data-cond') || 'amount',
      amount: parseInt(el.getAttribute('data-amount'), 10) || 0,
      min: parseInt(el.getAttribute('data-min'), 10) || 1,
      pids: (el.getAttribute('data-pids') || '').split(',').filter(Boolean),
      vids: (el.getAttribute('data-vids') || '').split(',').filter(Boolean),
      reward: el.getAttribute('data-reward') || 'none',
      variant: el.getAttribute('data-gift-variant') || '',
      code: (el.getAttribute('data-code') || '').trim()
    };
  });
  var giftCodes = [];   // les codes que c'est nous qui avons poses
  var giftBusy = false;

  // Le montant qui compte pour les paliers : le panier, cadeaux deduits.
  function netTotal(cart) {
    var t = cart.total_price || 0;
    (cart.items || []).forEach(function (it) {
      if (it.properties && it.properties[GIFT_PROP]) t -= it.final_line_price;
    });
    return t < 0 ? 0 : t;
  }

  function giftMet(g, cart) {
    var count = 0;
    var byP = {};
    var byV = {};
    (cart.items || []).forEach(function (it) {
      if (it.properties && it.properties[GIFT_PROP]) return;
      count += it.quantity;
      byP[String(it.product_id)] = (byP[String(it.product_id)] || 0) + it.quantity;
      byV[String(it.variant_id)] = (byV[String(it.variant_id)] || 0) + it.quantity;
    });
    if (g.cond === 'qty') return count >= g.min;
    if (g.cond === 'product' || g.cond === 'list') {
      var n = 0;
      if (g.vids.length) g.vids.forEach(function (v) { n += byV[v] || 0; });
      else g.pids.forEach(function (pid) { n += byP[pid] || 0; });
      return n >= g.min;
    }
    return netTotal(cart) >= g.amount;
  }

  function giftLine(cart, g) {
    var hit = null;
    (cart.items || []).forEach(function (it) {
      if (hit || !it.properties) return;
      if (it.properties[GIFT_PROP] === g.id) hit = it;
    });
    return hit;
  }

  function syncGifts(cart) {
    if (!gifts.length || giftBusy || busy) return;
    var adds = [];
    var updates = {};
    var codes = appliedCodes.slice();
    var codesMoved = false;

    gifts.forEach(function (g) {
      var met = giftMet(g, cart);
      if (g.reward === 'gift' && g.variant) {
        var line = giftLine(cart, g);
        if (met && !line) {
          var props = {};
          props[GIFT_PROP] = g.id;
          adds.push({ id: parseInt(g.variant, 10), quantity: 1, properties: props });
        } else if (met && line && line.quantity !== 1) {
          updates[line.key] = 1;
        } else if (!met && line) {
          updates[line.key] = 0;
        }
        return;
      }
      if (g.reward === 'code' && g.code) {
        var low = g.code.toLowerCase();
        var has = codes.some(function (c) { return c.toLowerCase() === low; });
        var mine = giftCodes.some(function (c) { return c.toLowerCase() === low; });
        if (met && !has) {
          codes.push(g.code);
          giftCodes.push(g.code);
          codesMoved = true;
        } else if (!met && has && mine) {
          codes = codes.filter(function (c) { return c.toLowerCase() !== low; });
          giftCodes = giftCodes.filter(function (c) { return c.toLowerCase() !== low; });
          codesMoved = true;
        }
      }
    });

    var hasUpdates = Object.keys(updates).length > 0;
    if (!adds.length && !hasUpdates && !codesMoved) return;

    giftBusy = true;
    var chain = Promise.resolve();
    // On retire d'abord : un cadeau perdu ne doit pas rester une seconde de trop.
    if (hasUpdates) chain = chain.then(function () { return postJSON('/cart/update.js', { updates: updates }); });
    if (adds.length) chain = chain.then(function () { return postJSON('/cart/add.js', { items: adds }); });
    if (codesMoved) chain = chain.then(function () { return postJSON('/cart/update.js', { discount: codes.join(',') }); });
    chain
      .then(getCart)
      .then(function (c) { giftBusy = false; render(c); })
      .catch(function () { giftBusy = false; });
  }

  /* --- regroupement des variantes d'un meme produit ------------------- */

  var mainVar = {};        // handle -> id de la variante principale de la fiche
  var mainPending = false;

  /*
    « La variante principale » est la premiere de la fiche produit, et la fiche
    n'est pas dans le panier : il faut aller la chercher. On rend d'abord avec
    ce qu'on sait, puis on refait le rendu une fois la reponse arrivee. Une
    fiche qui ne repond pas est marquee comme lue (0) pour ne pas la redemander
    a chaque rendu.
  */
  function ensureMain(items) {
    if (cfg.lineGroupFirst !== 'main' || mainPending) return;
    var todo = [];
    items.forEach(function (it) {
      if (it.handle && !(it.handle in mainVar) && todo.indexOf(it.handle) === -1) todo.push(it.handle);
    });
    if (!todo.length) return;
    mainPending = true;
    Promise.all(todo.map(function (h) {
      return getProduct(h).then(function (prod) {
        mainVar[h] = (prod && prod.variants && prod.variants.length) ? prod.variants[0].id : 0;
      });
    })).then(function () {
      mainPending = false;
      if (lastCart) render(lastCart);
    });
  }

  function groupsOf(items) {
    var order = [];
    var by = {};
    items.forEach(function (it) {
      var props = it.properties || {};
      // Un cadeau garde sa ligne a lui : il n'appartient pas au produit paye.
      var alone = !!props[GIFT_PROP] || !it.product_id;
      var k = alone ? 'solo:' + it.key : 'p:' + it.product_id;
      if (!by[k]) { by[k] = []; order.push(k); }
      by[k].push(it);
    });
    return order.map(function (k) { return by[k]; });
  }

  // Laquelle des variantes du groupe porte la photo et le nom.
  function headOf(group) {
    if (group.length < 2) return 0;
    if (cfg.lineGroupFirst === 'main') {
      var id = mainVar[group[0].handle];
      if (id) {
        for (var i = 0; i < group.length; i++) {
          if (String(group[i].variant_id) === String(id)) return i;
        }
      }
    } else if (cfg.lineGroupFirst === 'stock') {
      var at = -1;
      var low = null;
      group.forEach(function (it, i) {
        var n = stockFor(it.variant_id);
        if (n === null) return;
        if (low === null || n < low) { low = n; at = i; }
      });
      if (at > -1) return at;
    }
    // A defaut de renseignement, celle qui est arrivee la premiere au panier.
    return 0;
  }

  function linesHtml(items) {
    if (!cfg.lineGroup) {
      return items.map(function (it, i) { return lineHtml(it, i); }).join('');
    }
    ensureMain(items);
    var n = 0;
    return groupsOf(items).map(function (g) {
      if (g.length < 2) return lineHtml(g[0], n++);
      var rest = g.slice();
      var head = rest.splice(headOf(g), 1)[0];
      return '<div class="oi-lgroup">' +
        lineHtml(head, n++) +
        rest.map(function (it) { return lineHtml(it, n++, true); }).join('') +
      '</div>';
    }).join('');
  }

  function render(cart) {
    if (!cart || typeof cart.item_count !== 'number') return cart;
    lastCart = cart;

    var keepScroll = bodyEl ? bodyEl.scrollTop : 0;

    var items = cart.items.slice();

    /*
      Les couleurs qui portent un message d'urgence passent devant : c'est
      celles-la qu'on veut faire voir en premier. Le reste garde son ordre.
    */
    if (cfg.prioVids.length) {
      var head = [];
      var tail = [];
      items.forEach(function (it) {
        if (cfg.prioVids.indexOf(String(it.variant_id)) > -1) head.push(it);
        else tail.push(it);
      });
      items = head.concat(tail);
    }

    /*
      Un produit offert passe avant tout le reste, y compris les couleurs
      prioritaires : c'est ce qu'on a gagne, c'est ce qu'on veut voir.
    */
    if (cfg.giftFirst) {
      var gifts = [];
      var paid = [];
      items.forEach(function (it) {
        if (it.final_line_price === 0) gifts.push(it);
        else paid.push(it);
      });
      items = gifts.concat(paid);
    }

    /*
      La ligne qu'on vient de modifier garde sa place. On la reconnait a sa
      variante et a ses options, et jamais a sa seule cle : une application de
      remise peut reecrire les cles du panier entre deux rendus, et la ligne
      serait alors perdue de vue, donc laissee la ou le tri l'a mise.
      A defaut d'options identiques, la variante suffit : c'est bien la ligne
      qu'on vient de creer.
    */
    if (pinVariant) {
      var exact = null;
      var loose = null;
      items.forEach(function (it) {
        if (String(it.variant_id) !== pinVariant) return;
        if (!loose) loose = it;
        if (!exact && propSig(it.properties) === pinSig) exact = it;
      });
      var found = exact || loose;
      pinKey = found ? found.key : null;
      // La couleur epinglee n'est plus au panier : on oublie sa place.
      if (!found) { pinAt = null; pinVariant = ''; pinSig = ''; }
    }

    if (pinKey) {
      var pi = -1;
      items.forEach(function (it, i) { if (it.key === pinKey) pi = i; });
      if (pi < 0) { pinKey = null; pinAt = null; }
      else {
        // Sans place memorisee (un ajout), la ligne remonte en tete comme avant.
        var slot = pinAt === null ? 0 : Math.min(Math.max(pinAt, 0), items.length - 1);
        if (pi !== slot) items.splice(slot, 0, items.splice(pi, 1)[0]);
      }
    }

    linesEl.innerHTML = linesHtml(items);

    if (pinKey && pinFresh) {
      pinFresh = false;
      // La ligne n'a pas bouge : la vue non plus, sinon le panier sursaute.
      if (bodyEl && pinAt === null) bodyEl.scrollTop = 0;
      else if (bodyEl && keepScroll) bodyEl.scrollTop = Math.min(keepScroll, bodyEl.scrollHeight - bodyEl.clientHeight);
      var moved = linesEl.querySelector('[data-oi-line="' + (window.CSS && CSS.escape ? CSS.escape(pinKey) : pinKey) + '"]');
      if (moved) {
        moved.classList.add('is-flash');
        setTimeout(function () { moved.classList.remove('is-flash'); }, 1400);
      }
    } else if (bodyEl && keepScroll) {
      bodyEl.scrollTop = Math.min(keepScroll, bodyEl.scrollHeight - bodyEl.clientHeight);
    }
    hydrateLineOpts();
    if (emptyEl) emptyEl.hidden = cart.item_count > 0;
    if (countEl) countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    if (totalEl) totalEl.innerHTML = money(cart.total_price);

    /*
      Le prix barre : ce que le panier couterait sans aucune remise. On ne
      l'affiche que s'il y a vraiment un ecart, sinon on montrerait deux fois
      le meme chiffre.
    */
    if (wasEl) {
      var before = cart.original_total_price || cart.total_price + (cart.total_discount || 0);
      if (before > cart.total_price) {
        wasEl.hidden = false;
        wasEl.innerHTML = money(before);
      } else {
        wasEl.hidden = true;
      }
    }

    renderUrgency(cart);

    /*
      L'economie totale : la phrase vient des reglages, [somme] est remplace par
      le montant. Rien a afficher tant qu'il n'y a pas vraiment de remise.
    */
    if (saveEl) {
      if (cart.total_discount > 0 && cfg.saveText) {
        saveEl.hidden = false;
        saveEl.innerHTML = esc(cfg.saveText).replace('[somme]', money(cart.total_discount));
      } else {
        saveEl.hidden = true;
      }
    }

    /*
      Detail des remises appliquees au panier entier : c'est la que se voit
      l'argent gagne par un code promo. Les remises de ligne (les packs) sont
      deja affichees sous chaque produit.
    */
    if (discEl && discRows) {
      /*
        Les codes que la cliente peut retirer. Shopify ne les expose pas
        toujours dans /cart.js : quand la liste manque, on retombe sur le type
        de la remise, et retirer efface alors tous les codes de la session.
      */
      appliedCodes = (cart.discount_codes || [])
        .filter(function (c) { return c && c.applicable !== false && c.code; })
        .map(function (c) { return c.code; });

      var rows = (cart.cart_level_discount_applications || []).filter(function (d) {
        /*
          Un code entre mais sans effet sur ce panier alloue zero euro.
          Ecrire « moins 0 » ne dit rien et fait croire a un bug : on
          n'affiche la ligne que s'il y a vraiment de l'argent en moins.
        */
        return (d.total_allocated_amount || 0) > 0;
      }).map(function (d) {
        var title = dealTitle(d.title);
        var known = appliedCodes.some(function (c) { return c.toLowerCase() === title.toLowerCase(); });
        var byType = !appliedCodes.length && (d.type === 'discount_code' || d.type === undefined);
        var del = '';
        if (discRemove && (known || byType)) {
          del = ' <button type="button" class="oi-disc__del" data-oi-disc-del="' + esc(title) + '">' +
                esc(discRemoveLabel) + '</button>';
        }
        return '<div class="oi-disc__row"><span><span class="oi-disc__code">' + esc(title) + '</span>' + del + '</span>' +
               '<span>&minus;' + money(d.total_allocated_amount) + '</span></div>';
      });
      discRows.innerHTML = rows.join('');
      discEl.hidden = rows.length === 0;
    }

    if (ctaEl) {
      ctaEl.innerHTML = cfg.ctaTotal && cart.item_count
        ? esc(cfg.ctaLabel) + ' · ' + money(cart.total_price)
        : esc(cfg.ctaLabel);
    }

    renderGoals(cart);

    syncNextBtn();
    /*
      En dernier : les codes appliques viennent d'etre relus juste au-dessus,
      et c'est sur eux que les cadeaux a code se decident.
    */
    syncGifts(cart);
    notifyTheme(cart);
    document.dispatchEvent(new CustomEvent('orlivia:cart:rendered', { detail: cart }));
    return cart;
  }

  /* --- compte a rebours ----------------------------------------------- */

  if (timerEl) {
    var KEY = 'orlivia:panier:chrono';
    var mins = parseInt(timerEl.getAttribute('data-minutes'), 10) || 10;
    var tmplText = timerEl.getAttribute('data-text') || '';
    var endText = timerEl.getAttribute('data-end') || '';
    var keepAtZero = timerEl.getAttribute('data-keep') === 'true';
    var endAt = 0;
    try {
      endAt = parseInt(sessionStorage.getItem(KEY), 10) || 0;
      if (!endAt || endAt < Date.now()) {
        endAt = Date.now() + mins * 60000;
        sessionStorage.setItem(KEY, String(endAt));
      }
    } catch (e) { endAt = Date.now() + mins * 60000; }

    var tick = function () {
      var left = Math.max(0, endAt - Date.now());
      if (left === 0) {
        if (!keepAtZero) { timerEl.hidden = true; return; }
        timerEl.hidden = false;
        timerEl.textContent = endText;
        return;
      }
      var m = Math.floor(left / 60000);
      var sec = Math.floor((left % 60000) / 1000);
      var clock = (m < 10 ? '0' : '') + m + ':' + (sec < 10 ? '0' : '') + sec;
      timerEl.hidden = false;
      timerEl.innerHTML = esc(tmplText).replace('[temps]', '<strong>' + clock + '</strong>');
      setTimeout(tick, 1000);
    };
    tick();
  }

  /* --- ouverture et fermeture --------------------------------------- */

  function open(cart) {
    lastFocus = document.activeElement;
    root.classList.add('is-ready');
    setTimeout(function () { syncRailNav(); syncNextBtn(); layoutMarks(); }, 60);
    // Un souffle avant d'ajouter is-open, sinon la transition ne part pas.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        root.classList.add('is-open');
        root.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        var btn = root.querySelector('.oi-cart__close');
        if (btn) btn.focus();
      });
    });
    /*
      Le tiroir s'ouvre tout de suite avec ce qu'il sait deja. Si l'appelant
      vient de recevoir le panier, on l'affiche sans relire le reseau : c'est
      ce temps d'attente qui donnait l'impression d'un ajout lent.
    */
    if (cart && typeof cart.item_count === 'number') render(cart);
    else getCart().then(render);
  }

  function close() {
    pinKey = null;
    pinFresh = false;
    pinAt = null;
    pinVariant = '';
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (panel) panel.style.transform = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-oi-cart-close]')) { e.preventDefault(); close(); return; }

    var addBtn = t.closest('[data-oi-cart-add]');
    if (addBtn) {
      e.preventDefault();
      addVariant(parseInt(addBtn.getAttribute('data-oi-cart-add'), 10), 1);
      return;
    }

    var navBtn = t.closest('[data-oi-rail-nav]');
    if (navBtn) {
      e.preventDefault();
      var rail = navBtn.parentNode.querySelector('[data-oi-rail]');
      var card0 = rail && rail.querySelector('.oi-reco__card');
      var step = card0 ? card0.offsetWidth + 12 : 200;
      if (rail) rail.scrollBy({ left: step * parseInt(navBtn.getAttribute('data-oi-rail-nav'), 10), behavior: 'smooth' });
      return;
    }

    var line = t.closest('[data-oi-line]');
    if (!line) return;
    var key = line.getAttribute('data-oi-line');

    var qtyBtn = t.closest('[data-oi-qty]');
    if (qtyBtn) {
      var step = parseInt(qtyBtn.getAttribute('data-oi-qty'), 10);
      var cur = parseInt(line.querySelector('.oi-qty span').textContent, 10) || 0;
      changeLine(key, Math.max(0, cur + step));
      return;
    }

    if (t.closest('[data-oi-del]')) changeLine(key, 0);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  /* --- code promo ---------------------------------------------------- */

  if (promoBtn) {
    promoBtn.addEventListener('click', function () {
      var code = (promoInput.value || '').trim();
      if (!code) return;
      promoNote.hidden = false;
      promoNote.textContent = 'Vérification...';
      var before = 0;
      getCart()
        .then(function (c) {
          before = c.total_discount || 0;
          /*
            /cart/update.js accepte le parametre discount depuis mai 2025 : le
            code est pose sur le panier lui-meme, donc retirable ensuite. On
            garde /discount/CODE en secours pour les boutiques plus anciennes.
          */
          var codes = appliedCodes.slice();
          if (codes.indexOf(code) === -1) codes.push(code);
          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: codes.join(',') })
          }).then(function (r) {
            if (r.ok) return r;
            return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart', { credentials: 'same-origin' });
          });
        })
        .then(function () { return getCart(); })
        .then(function (cart) {
          render(cart);
          /*
            Rester sur le champ de saisie ne montre rien de ce qui vient de se
            passer. On descend la zone du pied jusqu'en bas : la ligne de
            remise et le total remis apparaissent d'eux-memes.
          */
          showDiscounts();
          var gained = (cart.total_discount || 0) - before;
          if (gained > 0) {
            promoNote.innerHTML = 'Code appliqué, vous économisez ' + money(gained) + ' de plus.';
          } else {
            var found = (cart.cart_level_discount_applications || []).some(function (d) {
              return (d.title || '').toLowerCase() === code.toLowerCase();
            });
            promoNote.textContent = found
              ? 'Code appliqué.'
              : 'Code enregistré. La remise apparaîtra au paiement si elle s’applique à votre panier.';
          }
        })
        .catch(function () { promoNote.textContent = 'Code impossible à vérifier pour le moment.'; });
    });
    promoInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); promoBtn.click(); }
    });
  }

  /* --- zone promo repliable ------------------------------------------- */

  var promoToggle = root.querySelector('[data-oi-promo-toggle]');
  var promoBody = root.querySelector('[data-oi-promo-body]');
  if (promoToggle && promoBody) {
    promoToggle.addEventListener('click', function () {
      var open = promoToggle.getAttribute('aria-expanded') === 'true';
      promoToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      promoBody.hidden = open;
      if (!open && promoInput) promoInput.focus();
    });
  }

  /* --- retirer un code promo ------------------------------------------ */

  if (discRows) {
    discRows.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-oi-disc-del]') : null;
      if (!btn) return;
      var title = btn.getAttribute('data-oi-disc-del') || '';
      var keep = appliedCodes.filter(function (c) { return c.toLowerCase() !== title.toLowerCase(); });
      btn.disabled = true;
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: keep.join(',') })
      })
        .then(function () { return getCart(); })
        .then(function (cart) {
          render(cart);
          if (promoNote) { promoNote.hidden = false; promoNote.textContent = 'Code retiré.'; }
        })
        .catch(function () {
          btn.disabled = false;
          if (promoNote) { promoNote.hidden = false; promoNote.textContent = 'Impossible de retirer le code pour le moment.'; }
        });
    });
  }

  /* --- glisser pour fermer (habillage par le bas) --------------------- */

  if (cfg.skin === 'bottom' && panel) {
    var startY = 0;
    var dy = 0;
    var dragging = false;

    panel.addEventListener('touchstart', function (e) {
      /*
        L'habillage par le bas peut n'etre actif que sur telephone. Sur une
        tablette ou un portable tactile large, le panneau est lateral : le
        glisser vers le bas le ferait descendre de travers. La feuille du bas
        occupe toute la largeur, le tiroir lateral non : ca suffit a trancher.
      */
      if (panel.getBoundingClientRect().width < window.innerWidth - 4) return;
      var body = root.querySelector('.oi-cart__body');
      // On ne prend le geste que si le contenu est deja en haut.
      if (body && body.scrollTop > 0 && !e.target.closest('[data-oi-cart-grip]')) return;
      dragging = true;
      startY = e.touches[0].clientY;
      dy = 0;
      panel.style.transition = 'none';
    }, { passive: true });

    panel.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      dy = e.touches[0].clientY - startY;
      if (dy > 0) panel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });

    panel.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      panel.style.transition = '';
      if (dy > panel.offsetHeight * 0.25) close();
      else panel.style.transform = '';
    });
  }

  /* --- prise en main des liens et des formulaires du site ------------- */

  /*
    Ce qui ouvre le tiroir : les declencheurs de panier du theme, et tout lien
    qui mene a la page panier. Le lien doit vraiment aller sur /cart (ou
    /fr/cart) : sans ce garde-fou, un simple lien vers l'accueil ouvrirait le
    tiroir.
  */
  var OPENERS = [
    '[data-drawer-toggle="drawer-cart"]',
    '[data-cart-toggle]',
    '#cart-icon-bubble',
    '.js-cart-button',
    '.header-cart-toggle'
  ].join(',');

  function isCartPath(href) {
    var path = href.replace(location.origin, '').split('#')[0];
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?(?:$|\?)/i.test(path);
  }

  document.addEventListener('click', function (e) {
    if (root.contains(e.target)) return;
    var hit = e.target.closest(OPENERS);
    if (!hit) {
      var a = e.target.closest('a[href]');
      if (!a || !isCartPath(a.getAttribute('href') || '')) return;
    }
    e.preventDefault();
    e.stopPropagation();
    open();
  }, true);

  /*
    Le compteur du header ecoute 'theme:cart:change'. Comme on a coupe
    l'ecouteur du theme, c'est a nous de l'emettre.
  */
  function notifyTheme(cart) {
    document.dispatchEvent(new CustomEvent('theme:cart:change', {
      detail: { cart: cart },
      bubbles: true
    }));
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    /*
      Le theme pose son propre ecouteur 'submit' sur le formulaire produit et
      fait son propre appel a /cart/add.js. On est en phase de capture, donc on
      passe avant lui : sans stopImmediatePropagation, les deux ajouts partent
      et l'article entre en double. On coupe la chaine ici, et on previent le
      theme du nouveau panier plus bas pour que sa pastille reste juste.
    */
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    setBusy(true);
    // Le tiroir s'ouvre avant meme la reponse, avec le panier d'avant : la
    // cliente voit qu'il se passe quelque chose au lieu d'attendre devant rien.
    if (cfg.openOnAdd) open(lastCart || {});
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      body: new FormData(form)
    })
      .then(function () { return getCart(); })
      .then(function (cart) {
        render(cart);
        setBusy(false);
        applyDealCode();
      })
      .catch(function () { setBusy(false); form.submit(); });
  }, true);

  // Ouverture depuis n'importe quel bouton du theme.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-oi-cart-open]')) { e.preventDefault(); open(); }
  });

  /*
    Animation au clic du bouton de paiement. Le gabarit pose la classe
    oi-cta--c-<effet> ; ici on marque l'appui (is-pressed) et, pour l'onde, on
    depose un cercle au point touche. La page part au checkout juste apres :
    l'effet doit etre court pour avoir le temps de se voir.
  */
  if (ctaEl) {
    ctaEl.addEventListener('pointerdown', function (e) {
      if (ctaEl.classList.contains('oi-cta--c-ripple')) {
        var r = ctaEl.getBoundingClientRect();
        var d = Math.max(r.width, r.height) * 2;
        var dot = document.createElement('span');
        dot.className = 'oi-ripple';
        dot.style.width = d + 'px';
        dot.style.height = d + 'px';
        dot.style.left = (e.clientX - r.left) + 'px';
        dot.style.top = (e.clientY - r.top) + 'px';
        ctaEl.appendChild(dot);
        setTimeout(function () { if (dot.parentNode) dot.parentNode.removeChild(dot); }, 700);
      }
      // on retire puis on force un calcul de style, sinon l'animation ne rejoue pas
      ctaEl.classList.remove('is-pressed');
      void ctaEl.offsetWidth;
      ctaEl.classList.add('is-pressed');
      setTimeout(function () { ctaEl.classList.remove('is-pressed'); }, 450);
    });
  }

  /*
    Dans l'editeur de theme, ce tiroir est rendu tout en bas de la page, apres
    le pied, et il est invisible tant qu'il est ferme. Quand on selectionne la
    section, l'editeur fait defiler la page jusqu'a elle et s'y accroche : on
    se retrouve coince tout en bas devant du vide, sans pouvoir remonter.
    On ouvre donc le tiroir des qu'il est selectionne, il y a quelque chose a
    regarder, et on le referme a la deselection en rendant le defilement.
  */
  if (window.Shopify && window.Shopify.designMode) {
    var mine = function (e) { return e.target && e.target.contains && e.target.contains(root); };
    var editorOpen = function () { getCart().then(function (cart) { render(cart); open(cart); }); };
    document.addEventListener('shopify:section:select', function (e) { if (mine(e)) editorOpen(); });
    document.addEventListener('shopify:block:select', function (e) { if (mine(e)) editorOpen(); });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (!mine(e)) return;
      close();
      // ceinture et bretelles : la page doit toujours redevenir defilante
      document.documentElement.style.overflow = '';
    });
  }

  window.orliviaCart = { open: open, close: close, refresh: function () { return getCart().then(render); } };

  root.classList.add('is-ready');
  getCart().then(render);
})();
